export const grid = {
    mt: 3,
    display: 'grid',
    gridTemplateColumns: {
        xs: '1fr',
        sm: 'repeat(2, minmax(0, 1fr))',
        lg: 'repeat(3, minmax(0, 1fr))',
        xl: 'repeat(4, minmax(0, 1fr))',
    },
    gap: { xs: 2.5, md: 3 },
};

export const empty = {
    gridColumn: '1 / -1',
    background: 'linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.015) 100%)',
    border: '1px solid rgba(187,188,188,0.12)',
    borderRadius: '22px',
    py: 8,
    textAlign: 'center',
    color: 'var(--ecal-lightgrey)',
    fontSize: '0.9375rem',
};
